/* mo-size-compare.js — the "that's about the size of…" line shared by every accuracy calculator, so they all word it
   the same way: the accuracy page cards (assets/accuracy-calc.js) and the LX1 accuracy pop-up
   (assets/lx1-accuracy-modal.js). Load it (deferred) before either script.
   Comparisons are typed in the theme editor, one per line: "size | comparison | plural (optional)", in the slider's own
   units, e.g. "94 | the length of a basketball court | basketball courts". The one closest to the size (by ratio) is
   used, worded by six templates: about / over / under / half / count (has a plural) / times (no plural), where [ref] is
   the comparison, [refs] its plural and [n] how many (in halves: 1½, 2, 2½…).
   API: window.moSizeCompare.parse(text) -> list; window.moSizeCompare.line(words, list, size) -> sentence or ''. */
(function () {
  'use strict';
  if (window.moSizeCompare) return;

  function parse(text) {
    return String(text || '').split(/\r?\n/).map(function (row) {
      var p = row.split('|').map(function (x) { return x.trim(); });
      var size = parseFloat((p[0] || '').replace(/,/g, ''));
      return size > 0 && p[1] ? { size: size, one: p[1], many: p[2] || '' } : null;
    }).filter(Boolean);
  }
  function halves(n) { // 1.5 -> "1½", 2 -> "2"
    var h = Math.round(n * 2) / 2, whole = Math.floor(h);
    return (whole || '') + (h - whole ? '½' : '');
  }
  function line(words, list, v) {
    var best = null;
    (list || []).forEach(function (r) { var d = Math.abs(Math.log(v / r.size)); if (!best || d < best.d) best = { r: r, d: d }; });
    if (!best || !words) return '';
    var r = best.r, n = v / r.size;
    var put = function (t) { return (t || '').replace('[ref]', r.one).replace('[refs]', r.many).replace('[n]', halves(n)); };
    if (n >= 0.9 && n <= 1.1) return put(words.about);
    if (n > 1.1 && n < 1.4) return put(words.over);
    if (n >= 1.4) return put(r.many ? words.count : words.times);
    if (n >= 0.65) return put(words.under);
    return put(words.half);
  }

  window.moSizeCompare = { parse: parse, line: line };
})();
